import ResourceAPI, { Resource, SearchParams } from 'api/ResourceAPI';
import TMOrderScope from 'types/entities/OrderScope';

export default class TMOrderScopesApiService {
  public static instance: TMOrderScopesApiService;

  public static baseUrl = 'tmorder-scopes' as Resource;

  public static get Instance() {
    // eslint-disable-next-line no-return-assign
    return TMOrderScopesApiService.instance || (TMOrderScopesApiService.instance = new TMOrderScopesApiService());
  }

  public static async getOrderScopesById(order_id: number, searchParams?: SearchParams) {
    try {
      const { data } = await ResourceAPI.get(this.baseUrl, {
        order_id,
        size: '-1',
        ...searchParams,
      });
      return data.datas;
    } catch (error: unknown) {
      return [];
    }
  }
}
